import { PropsWithChildren, createContext, useEffect, useRef } from 'react';
import { DashboardFiltersStore, createStore } from './dashboard-filters.store';
import { KeyToFilterConfig } from './types';

interface ProviderProps {
  filters: KeyToFilterConfig;
}

interface DashboardFilterContextProps {
  store: DashboardFiltersStore;
}

export const DashboardFilterContext = createContext<DashboardFilterContextProps>({
  store: createStore({ filters: {} }),
});

export const DashboardFilterProvider: React.FC<PropsWithChildren<ProviderProps>> = ({
  filters,
  children,
}) => {
  const store = useRef(createStore({ filters })).current;

  return (
    <DashboardFilterContext.Provider value={{ store }}>{children}</DashboardFilterContext.Provider>
  );
};
